export const ACTION_CODE = 'CONTRACTOR' + 'INVOICES' + '_ACTION';
